define([
	"dojo/_base/declare",
	"dojo/keys",
	"dijit/focus",
	"dijit/form/_TextBoxMixin",
	"dijit/form/FilteringSelect",
	"csi/html",
	"csi/service/sessionService",
	"csi/store/common",
	"./_ComboBoxMixin",
	"./_ErrorMessageMixin",
	"./_HasDropDownMixin"
], function(declare, keys, focus, _TextBoxMixin, FilteringSelect, html, { isAutoCompleteEnabled }, {DISABLED_PROPERTY}, _ComboBoxMixin, _ErrorMessageMixin, _HasDropDownMixin) {

	// DOJO_INTERNAL

	return declare([FilteringSelect, _ComboBoxMixin, _ErrorMessageMixin, _HasDropDownMixin], {
		// String: value to restore when widget goes invalid
		//_csiResetValue: null,

		/** @property {boolean} bClickNewAction - indicates if the user clicks the New Action if any */
		bClickNewAction: false,

		csiResetValue: function(/*Any?*/resetValue) {
			// summary: reset to last known good value
			var v = resetValue || this._csiResetValue || this._resetValue;
			if (v && (v != this.get("value"))) {
				this.set("value", v, false);

				// FIX: should we use below instead from _AutoCompleterMixin::_setBlurValue?
				//this._setValueAttr(v, true);
			}
		},

		hasActionsWithoutAutocomplete: function() {
			// summary: check if autoComplete is off and store action data exists
			return !this.get("autoComplete") && this.store.actionData && this.store.actionData.length;
		},

		reinitializeValue: function(/*Any*/value) {
			// summary: set initial value of widget after its creation - dijit widgets work on assumption that onChange should
			// be called on any value change after creation, but in some cases it is not possible to set initial value until later.
			this._resetValue = this._lastValueReported = value;
			this.set("value", value, null);
		},

		_processInput: function(/*Event*/ evt) {
			// summary: (C8-19391) fix error when allow to compare type string to integer when comparing key "8" (number "eight") with key 8 (escape)
			// this code fixes dojo bug from dijit/form/_SearchMixin->_processInput()
			if (this.disabled || this.readOnly) {
				return;
			}
			// preserve value before calling inherited
			var _maskValidSubsetError = this._maskValidSubsetError;

			this.inherited(arguments);

			var key = evt.charOrCode;

			// reset to false - same as in inherited
			this._prev_key_backspace = false;
			// restore saved value before properly re-done comparison
			this._maskValidSubsetError = _maskValidSubsetError;

			// this is real fix: use "===" instead of "=="
			if (key === keys.DELETE || key === keys.BACKSPACE) {
				this._prev_key_backspace = true;
				this._maskValidSubsetError = true;
			}

		},

		_handleOnChange: function(/*anything*/newValue, /*Boolean?*/priorityChange) {
			// summary: track last valid change
			this.inherited(arguments);

			if (this.item) {
				if (this.textbox) {
					this.textbox.title = this.item.name || this.item.Name || "";
				}
				this._csiResetValue = newValue;
			}
		},

		_onFocus: function(/*String*/by) {
			// summary: only open drop-down and select text when triggered by mouse and widget is still in focus (C8-3316)
			this.inherited(arguments);

			this.defer(function() {
				if (this.focusNode == focus.curNode) {
					if (by == 'mouse') {
						this.toggleDropDown();
					}

					_TextBoxMixin.selectInputText(this.focusNode);
				}
			});
		},

		_onDropDownMouseDown: function(/*Event*/ e) {
			// summary: make sure widget in focus when clicking drop-down button (Ticket #13790)
			if (this.disabled || this.readOnly) return;
			this.inherited(arguments);
			this.focus();
			var focusNode = this.focusNode;
			this.defer(function() {
				_TextBoxMixin.selectInputText(focusNode);
			});
		},

		_onKey: function(/*Event*/e) {
			// summary: restore value if escape pressed

			// tab events while inline editing seem to come through after the widget is destroyed in IE, so add check here
			// to make sure widget still exists
			if (!html.exists(this)) {
				return;
			}

			// if ENTER or TAB key pressed and preventDefault called, then do nothing
			const {keyCode} = e;

			if (e.defaultPrevented && (keyCode === keys.TAB || keyCode === keys.ENTER)) {
				return;
			}

			this.inherited(arguments);

			if ((keyCode == keys.ESCAPE) && !e.cancelBubble) {
				this.csiResetValue();

				// Firefox will abort active request without below statement - we want request to continue so that
				// results can be reused for next query
				e.preventDefault();
			}
		},

		_setBlurValue: function() {
			// summary: restore last valid value if blurred with invalid value
			// FIX: this should be optional - if in form, should we just leave invalid values alone?
			var resetValue = this._csiResetValue;
			// set fetchProperties to noActionData as query option so goToDialog or any other action is not triggered on blur
			this.fetchProperties = this.fetchProperties || {};
			this.fetchProperties.noActionData = true;

			// set back to undefined if needed to make sure restore the valid value when user type in invalid value
			this.item = (this.item && Object.keys(this.item).length < 1) ? undefined : this.item;

			this.inherited(arguments);

			delete this.fetchProperties.noActionData;

			if (!this.item || this.item[DISABLED_PROPERTY]) {
				this.csiResetValue(resetValue);
			}
		},

		/**
		 * @override
		 * This function should not include action data when querying store
		 */
		_setDisplayedValueAttr(label, priorityChange) {
			this.fetchProperties = this.fetchProperties || {};
			this.fetchProperties.noActionData = true;
			this.inherited(arguments);
			delete this.fetchProperties.noActionData;
		},

		/**
		 * Override to set the autoComplete property if needed
		 */
		postCreate: function() {
			// in other countries, like China, Japan etc., when user input a word, they have to input several English letters before they can get
			// the actual word, So, don't need to autoComplete
			this.autoComplete = isAutoCompleteEnabled();

			this.inherited(arguments);
		},

		/**
		 * overrides to make sure the validate doesn't happen when the query completes
		 * @param {Object} results
		 * @param {Object} query
		 * @param {Object} options
		 */
		_openResultList: function(results, query, options) {
			this.item = (this.item == undefined) ? {} : this.item;
			this.inherited(arguments);
		}
	});
});